module.exports = __webpack_public_path__ + "img/flowus_02.92c05485.png";